import { useContext } from 'react';
import { AuthModalContext } from '~/components/contexts/AuthModalContext/AuthModalContext';
import useUserContext from './useUserContext';

export const useAuthModal = () => {
  const context = useContext(AuthModalContext);
  const { user } = useUserContext();

  if (!context) {
    throw new Error('useAuthModal must be used within an AuthModalProvider');
  }

  const { showAuthModal, hideAuthModal } = context;

  const requireAuth = (callback: () => void) => {
    if (!user) {
      showAuthModal();
      return;
    }
    callback();
  };

  return {
    showAuthModal,
    hideAuthModal,
    requireAuth,
    isAuthenticated: !!user,
  };
}; 